module.exports = __webpack_public_path__ + "img/icon.9a47dc14.png";